import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMe } from '../../lib/auth.tsx';
export function EmailBanner() {
  const me = useMe();
  const key = `email-banner:${me.id}`;
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(key) === '1');
  if (me.emailVerified || dismissed) return null;
  return <div className="notice row" data-nav-row><Link to="/settings/security">Añade tu correo para poder recuperar tu cuenta</Link><button className="btn btn-ghost btn-sm" aria-label="Cerrar aviso de correo" onClick={() => { sessionStorage.setItem(key, '1'); setDismissed(true); }}>Cerrar</button></div>;
}
